import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import {
  CrntButton,
  CrntButtonAlt,
  CrntIcon,
} from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import {
  CommodityOfferLayoutType,
  CommodityOfferLabels,
} from '../../commodity-offers.model';
import { CommodityOfferCardComponent } from '../../commodity-offer-card/commodity-offer-card.component';
import { CommodityOfferEDHeaderComponent } from '../../partials/ed/commodity-offer-header/commodity-offer-header.component';
import { CommodityOfferPriceTagComponent } from '../../partials/shared/commodity-offer-price-tag/commodity-offer-price-tag.component';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';
import { CommodityOfferBudgetbillProposalComponent } from '../../partials/shared/commodity-offer-budgetbill-proposal/commodity-offer-budgetbill-proposal.component';
import { CommodityOfferViewTariffsComponent } from '../../partials/shared/commodity-offer-view-tariffs/commodity-offer-view-tariffs.component';
import { CommodityOfferEDProductBreakdownComponent } from '../../partials/ed/commodity-product-breakdown/commodity-product-breakdown.component';
import { CommodityVerticalOfferDropdownComponent } from '../../partials/ed/commodity-vertical-offer-dropdown/commodity-vertical-offer-dropdown.component';
import { CommonModule } from '@angular/common';
import { GenericRichTextDirective } from '@core/jss-utils';

@Component({
  selector: 'ed-consumer-acquisition-commodity-offer',
  templateUrl: './ed-consumer-acquisition-commodity-offer.component.html',
  styleUrls: ['./ed-consumer-acquisition-commodity-offer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CommodityOfferCardComponent,
    CommodityOfferEDHeaderComponent,
    CommodityOfferPriceTagComponent,
    CommodityOfferAccordionComponent,
    CommodityOfferBudgetbillProposalComponent,
    CommodityOfferViewTariffsComponent,
    CommodityOfferEDProductBreakdownComponent,
    CommodityVerticalOfferDropdownComponent,
    CrntButtonAlt,
    AutomationIdDirective,
    CSCaptureDirective,
    CrntIcon,
    CrntButton,
    GenericRichTextDirective,
  ],
})
export class EdConsumerAcquisitionCommodityOfferComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() variant?: CommodityOfferLayoutType;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() useAlternateCommodityTariffView = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hideCommodityProductBreakdownTable = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() ensureHorizontalAlignment = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showMemberGetMember = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showTariffs = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableNewOfferCardTitles = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() termijnbedragVariantA = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() termijnbedragVariantB = false;

  @Output() openMoreInfo = new EventEmitter<void>();
  @Output() viewTariffs = new EventEmitter<void>();
  @Output() selectOffer = new EventEmitter<void>();
  @Output() openTariffDropdown = new EventEmitter<void>();
  @Output() closeTariffDropdown = new EventEmitter<void>();
}
